export const manifest = {
  screens: {
    scr_majbko: { name: "Home", route: "/" },
  },
}
